import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-citationreason',
    templateUrl: './citationreason.component.html',
    styleUrls: ['./citationreason.component.scss'],
    standalone: false
})
export class CitationReasonComponent extends Busyable implements OnInit {
  public Model: any = null;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public enforcementService: EnforcementService
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.params['id'];
    if (id) {
      await this.loadCitationReason(id);
    }
  }

  private async loadCitationReason(id: string): Promise<void> {
    try {
      this.Busy();
      this.Model = await this.apiService.Get(`enforcement/infringement-types/${id}`);
    } finally {
      this.StopBusy();
    }
  }
} 
